import { render, staticRenderFns } from "./Rare.vue?vue&type=template&id=07a8dfb2&scoped=true&"
import script from "./Rare.vue?vue&type=script&lang=js&"
export * from "./Rare.vue?vue&type=script&lang=js&"
import style0 from "./Rare.vue?vue&type=style&index=0&id=07a8dfb2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a8dfb2",
  null
  
)

export default component.exports